import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import WarehouseInventoryEdit from './WarehouseInventoryEdit';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, Popconfirm, Row, Select, Space } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification'
import getList from '../../universal/getList';


export default function WarehouseInventory(props: any) {
    const apiId = 'warehouseInventory';
    const ref = useRef<any>(undefined);
    let wmService: any = systemConfig.wmService;
    // const [warehouseCategoriesData, setWarehouseCategoriesData] = useState<any>([]);
    const [form] = Form.useForm()
//  const selfStart = Form.useWatch("selfStart", form) as any;
//  const selfEnd = Form.useWatch("selfEnd", form) as any;
 const warehouseCategoriesIds = Form.useWatch("warehouseCategoriesIds", form) as any;


    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;
    const [isInitInventory, setIsInitInventory] = useState<boolean>(false)
    useEffect(() => {
        getEntrepot(contextData?.currentEntrepotId)
        const fetchData = async () => {
            // let warehouseCategoriesData = await fetchApi.GET(wmService, {
            //     apiId: "warehouseCategories",
            //     apiExtend: 'showList'
            // })


            // if (warehouseCategoriesData.success) {

            //     setWarehouseCategoriesData(warehouseCategoriesData.data)
            // }
        }
        if (contextData?.currentEntrepotId && contextData?.refresh) {

            onRefresh({ entrepotId: contextData?.currentEntrepotId,warehouseCategoriesIds })
        }
        fetchData()
    })
    /**获取仓库数据 */
    const getEntrepot = (entrepotId: string) => {
        fetchApi.GET(wmService, {
            apiId: "entrepot",
            apiExtend: "showSingle",
            apiVariable: entrepotId

        }).then(res => {
            setIsInitInventory(res.data.isInitInventory)

        }).catch((err) => {
            console.log("err", err);

        })
    }
    const onRefresh = (item: any) => {
        let { entrepotId,selfStart,selfEnd,warehouseCategoriesIds } = item
        const currentData: initDataType = {
            apiId,
            sendPageData: { entrepotId,selfStart,selfEnd,warehouseCategoriesIds }
        }
        ref.current.initData(currentData);
        setContextData({ ...contextData, refresh: false, })

    }
    //表头
    const columnsHead = [
        {
            title: '仓库',
            dataIndex: 'entrepot',
            render: (text: any) => (text.entrepotName)
        },
        {
            title: '产品',
            dataIndex: 'product',
            render: (text: any) => (text.productName)
        },
        {
            title: '单位',
            dataIndex: 'product',
            render: (text: any) => (text.productUnit.productUnitName)
        },
        {
            title: '期初数',
            dataIndex: 'openingQuantity',
        },
        {
            title: '期初金额',
            dataIndex: 'openingPrice',
        },
        {
            title: '库存',
            dataIndex: 'quantity',
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '仓库库存',
        apiId,
        showStates: false,
        columns,
        pagination: true,
        showAdd: !isInitInventory,
        showDelete: !isInitInventory,
        showEdit: !isInitInventory,
        EditComponent: WarehouseInventoryEdit,
        sendPageData: { entrepotId: contextData?.currentEntrepotId,warehouseCategoriesIds }

    };
    const initInventory = () => {
        fetchApi.POST(wmService, {
            apiId,
            apiExtend: "initWarehouseInventory",
            apiData: {
                entrepotId: contextData?.currentEntrepotId
            }
        }).then((res) => {
            getEntrepot(contextData?.currentEntrepotId)
            antMessage("success", '成功', "初始化库存成功!");
        }).catch((err) => {
            antMessage('error', '失败', JSON.stringify(err));
            console.log(err);

        })
    }
    const onChangeWarehouseCategories = (e: any, option: any) => {
        onRefresh({ entrepotId: contextData?.currentEntrepotId,warehouseCategoriesIds:e})
         
    }
    return (
        <>
            <Space>
                <Popconfirm placement={"bottom"} title="确定要需要初始化库存吗？" onConfirm={initInventory} okText="确定" cancelText="取消">
                    <Button disabled={isInitInventory} danger>初始化库存确认</Button>
                </Popconfirm>
            </Space>

            <Form
                form={form}
            // onFinish={onFinish}
            // initialValues={initialValues}
            >
                {/* <Row>

                  
                    <Col span={6}>
                        <Form.Item
                            label="大类"
                            name="warehouseCategoriesIds"
                        >
                            <Select
                                onChange={onChangeWarehouseCategories}
                                mode="multiple"
                                showSearch
                                placeholder="大类"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(warehouseCategoriesData, 'warehouseCategoriesName')}
                            </Select>
                        </Form.Item>
                    </Col>









                </Row> */}
            </Form>
            <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>
        </>
    )
}
